var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "icons-settings-modal",
            title: "Icons Settings",
            centered: "",
            size: "l",
            "ok-title": "Save",
          },
          on: { ok: _vm.handleSave },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "inputs-container" },
              _vm._l(_vm.urls, function (url, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "d-flex mb-2" },
                  [
                    _c("b-form-input", {
                      staticClass: "mr-2",
                      attrs: { value: url, placeholder: "Enter the icon URL" },
                      on: {
                        input: (value) => _vm.handleURLInput(value, index),
                      },
                    }),
                    _vm._v(" "),
                    _vm.urls.length > 1
                      ? _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "outline-danger" },
                            on: { click: () => _vm.handleDeleteBtn(index) },
                          },
                          [_c("b-icon", { attrs: { icon: "trash" } })],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "outline-primary" },
                    on: { click: _vm.handleAddUrlBtn },
                  },
                  [_vm._v("\n          Add URL\n        ")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Placement Orientation" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.placementOrientation },
                        model: {
                          value: _vm.placementOrientationValue,
                          callback: function ($$v) {
                            _vm.placementOrientationValue = $$v
                          },
                          expression: "placementOrientationValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Placement Order" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.placementOrder },
                        model: {
                          value: _vm.placementOrderValue,
                          callback: function ($$v) {
                            _vm.placementOrderValue = $$v
                          },
                          expression: "placementOrderValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Icons Grid" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.iconsGridOptions },
                        model: {
                          value: _vm.iconsGridValue,
                          callback: function ($$v) {
                            _vm.iconsGridValue = $$v
                          },
                          expression: "iconsGridValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isIconsGridEnabled
                ? [
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Number of Icons in a row" } },
                          [
                            _c("b-input", {
                              attrs: { type: "number", min: "1" },
                              model: {
                                value: _vm.iconsInRow,
                                callback: function ($$v) {
                                  _vm.iconsInRow = _vm._n($$v)
                                },
                                expression: "iconsInRow",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Number of Rows" } },
                          [
                            _c("b-input", {
                              attrs: { type: "number", min: "1" },
                              model: {
                                value: _vm.iconsRows,
                                callback: function ($$v) {
                                  _vm.iconsRows = _vm._n($$v)
                                },
                                expression: "iconsRows",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Horizontal Offset" } },
                          [
                            _c("b-input", {
                              attrs: { type: "number" },
                              model: {
                                value: _vm.horizontalOffset,
                                callback: function ($$v) {
                                  _vm.horizontalOffset = _vm._n($$v)
                                },
                                expression: "horizontalOffset",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Vertical Offset" } },
                          [
                            _c("b-input", {
                              attrs: { type: "number" },
                              model: {
                                value: _vm.verticalOffset,
                                callback: function ($$v) {
                                  _vm.verticalOffset = _vm._n($$v)
                                },
                                expression: "verticalOffset",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.isShowPage
            ? _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "X", "label-cols": "1" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.left,
                              callback: function ($$v) {
                                _vm.left = _vm._n($$v)
                              },
                              expression: "left",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Y", "label-cols": "1" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.top,
                              callback: function ($$v) {
                                _vm.top = _vm._n($$v)
                              },
                              expression: "top",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "W", "label-cols": "1" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.width,
                              callback: function ($$v) {
                                _vm.width = _vm._n($$v)
                              },
                              expression: "width",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "H", "label-cols": "1" } },
                        [
                          _c("b-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.height,
                              callback: function ($$v) {
                                _vm.height = _vm._n($$v)
                              },
                              expression: "height",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }